<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="timeValue" label="时间值">
                        <a-input-group compact>
                          <a-input-number v-model="form.timeValue" :min="1" :style="{ width: 'calc(100% - 80px)' }" :placeholder="$t('通用.输入.请输入')" />
                          <a-select v-model="form.timeUnit" style="width: 80px">
                            <a-select-option value="分钟">分钟</a-select-option>
                            <a-select-option value="小时">小时</a-select-option>
                          </a-select>
                        </a-input-group>
                  </a-form-model-item>
                  <a-form-model-item prop="sort" >
                        <span slot="label" ><a-tooltip>排序<template slot="title">排序</template></a-tooltip> </span>
                        <a-input-number v-model="form.sort" :placeholder="$t('通用.输入.请输入')+'排序'" :min="0" style="width: 100%" />
                  </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getTaskTimeConfig, addTaskTimeConfig, updateTaskTimeConfig } from '@/api/task/taskTimeConfig'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          id: null,
                          configKey: null,
                          configValue: null,
                          sort: null,
                          timeValue: null,
                          timeUnit: '分钟'
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
                              timeValue: [{ required: true, message: '时间值'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          id: null,
                          configKey: null,
                          configValue: null,
                          sort: null,
                          timeValue: null,
                          timeUnit: '分钟'
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskTimeConfig({"id":id}).then(response => {
        const data = response.data
        this.form.id = data.id
        this.form.configKey = data.configKey
        this.form.configValue = data.configValue
        this.form.sort = data.sort
        // 从 configKey 解析数值和单位，如 "30分钟" 或 "1小时"
        const match = data.configKey ? data.configKey.match(/^(\d+)(分钟|小时)$/) : null
        if (match) {
          this.form.timeValue = parseInt(match[1])
          this.form.timeUnit = match[2]
        } else {
          this.form.timeValue = null
          this.form.timeUnit = '分钟'
        }
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          // 构造 configKey：数字 + 单位
          this.form.configKey = this.form.timeValue + this.form.timeUnit
          // 转换 configValue 为分钟
          if (this.form.timeUnit === '小时') {
            this.form.configValue = this.form.timeValue * 60
          } else {
            this.form.configValue = this.form.timeValue
          }
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateTaskTimeConfig(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addTaskTimeConfig(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
